import { render, staticRenderFns } from "./admin-list.vue?vue&type=template&id=008e2642&scoped=true"
import script from "./admin-list.vue?vue&type=script&lang=js"
export * from "./admin-list.vue?vue&type=script&lang=js"
import style0 from "./admin-list.vue?vue&type=style&index=0&id=008e2642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e2642",
  null
  
)

export default component.exports